import React, { useEffect, useState, useContext } from 'react';
import { TextField, Button, Grid, ListItemIcon, ListItemText, OutlinedInput, FormControl, InputLabel } from '@material-ui/core/';
import { useParams, Redirect } from 'react-router-dom';
import Content from '../components/Content';
import { validateVal, isEmpty } from 'utils/helpers';
import { sendGetRequest, sendPostRequest, sendDeleteRequest } from 'utils/api';
import useStyles from 'styles/forms';
import { formPropTypes, formDefaultPropValues } from 'proptypes/index';
import Blocker from 'components/Blocker';
import { ErrorAlert } from 'components/Alerts';
import BasicDropDown from './forms/formElements/BasicDropDown';
//import PickList from './forms/formElements/PickList';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { useHistory } from 'react-router-dom';
//import ListAltIcon from '@material-ui/icons/ListAlt';
import ChevronRightTwoToneIcon from '@material-ui/icons/ChevronRightTwoTone';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
//import { truncate } from 'lodash';
import { format } from 'date-fns';
import { UserContext } from '../contexts';
import NewReleasesIcon from '@material-ui/icons/NewReleases';
import { get } from 'lodash';

const options = [
	'Create',
	'Search',
	'Edit', 
	'Delete',
	'Back'
  ];
  
const ITEM_HEIGHT = 48;

const table = 'masterlist';


const validateForm = (key, value) => {
	const errors = {};
	switch (key) {
		case 'assignee':
			errors.assignee = validateVal({
				value: value,
				required: true,
				maxLength: 100,
			});
			break;
		case 'assetTag':
			errors.assetTag = validateVal({
				value: value,
				maxLength: 100,
				required: true,
			});
			break;
		case 'assetDesc':
			errors.assetDesc = validateVal({
				value: value,
				maxLength: 1000,
				required: true,
			});

			break;
		case 'acqDate':
				errors.acqDate = validateVal({
					value: value,
					maxLength: 30,
					required: true,
				});
	
				break;

		case 'acqCost':
			errors.acqCost = validateVal({
				value: value,
				maxLength: 30,
				required: true,
			});

			break;
		
		case 'uom':
			errors.uom = validateVal({
				value: value,
				maxLength: 50,
				required: true,
			});

			break;
	
		case 'businessUnit':
			errors.businessUnit = validateVal({
				value: value,
				maxLength: 100,
				required: true,
			});

			break;

		case 'department':
			errors.department = validateVal({
				value: value,
				maxLength: 100,
				required: true,
			});

			break;

		case 'locationId':
			errors.locationId = validateVal({
				value: value,
				maxLength: 100,
				required: true,
			});

			break;

		case 'docNo':
			errors.docNo = validateVal({
				value: value,
				maxLength: 100,
				required: true,
			});

			break;

		case 'docType':
			errors.docType = validateVal({
				value: value,
				maxLength: 100,
				required: true,
			});

			break;


		default:
			break;
	}
	return errors;
};

const validateFormValues = (values) => {
	let errors = [];
	Object.keys(values).forEach((key) => {
		errors = { ...errors, ...validateForm(key, values[key]) };
	});
	return errors;
};

const actions = {create: 'create', edit: 'edit', delete: 'delete', close:'close', search:'search'}

const data = [{
	
}]

const columns = [
    { field: 'empId', headerName: 'ID', width: 150 },
    {
      field: 'lastName',
      headerName: 'Last name',
      width: 150,
      editable: false,
	  sortable: true,
    },
    {
      field: 'firstName',
      headerName: 'First name',
      width: 150,
      editable: false,
	  sortable: true,
    }
  ];

//   [id_master]
//   ,[assignee]
//   ,[assignee_emp_id]
//   ,[role]
//   ,[email_add]
//   ,[username]
//   ,[asset_tag]
//   ,[asset_desc]
//   ,[serial_no]
//   ,[uom]
//   ,[asset_stat]
//   ,[acq_date]
//   ,[acq_cost]
//   ,[business_unit]
//   ,[department]
//   ,[location_id]
//   ,[doc_no]
//   ,[doc_type]
//   ,[remarks]

const setTempDate = () =>{
	const date = new Date();
	return `${format(date, 'dd.MM.yyyy')}`
}


function getNow() {
    var date = new Date();
    var dateStr =
        ("00" + (date.getMonth() + 1)).slice(-2) + "/" +
        ("00" + date.getDate()).slice(-2) + "/" + date.getFullYear() + " " +
        ("00" + date.getHours()).slice(-2) + ":" +
        ("00" + date.getMinutes()).slice(-2)
    return dateStr
}

const initializeCreate = () =>{

	return ({
	  idMaster: '0'
	  ,assetTag: ''
	  ,assetDesc: ''
	  ,serialNo: 'NA'
	  ,uom: ''
	  ,assetStat: ''
	  ,acqDate: new Date()
	  ,remarks: ''
	  ,quantity: 1
	  ,cic:''
	  ,originatingBu:'HEDCOR, INC. - DAVAO'
	});

}



const AssetsForm = (props) => {
	const context = useContext(UserContext);

	const classes = useStyles();
	const params = useParams();
	const history = useHistory();
	const { closeModal } = props;

	const [departments, setDepartments] = useState([]);
	const [companies, setCompanies] = useState([]);
	const [uom, setUom] = useState([]);
    const [assetStatuses, setAssetStatuses] = useState([]);
	const [inputDisabled, setInputDisabled] = useState(true);
	const [insurance, setInsurance] = useState([]);
	const [busUnit, setbusUnit] = useState([]);
	const [formValues, setFormValues] = useState({});
	const [formErrors, setFormErrors] = useState({});
	const [requesting, setRequesting] = useState(false);
	const [success, setSuccess] = useState(null);
	const [status, setStatus] = useState(null);
	const [action, setAction] = useState(null);
	const [locations,setLocations] = useState([]);
	const [anchorEl, setAnchorEl] = React.useState(null);
	const open = Boolean(anchorEl);

	useEffect(() => {
		
		initializeLists();

		if (parseInt(params.id)) {
			console.log("WENT HERE");
			const path = `/${table}/${params.id}`;
			setRequesting(true);
			sendGetRequest(path).then((res) => {
				setRequesting(false);
				console.log("ASSET DATA", res.data);

				if (res.error) {
					setSuccess(false);
					setStatus(res.error.message);
					return;
				}
				
				setStatus(res.status);
				setFormValues({...res.data[0], totalCost: res.data[0].acqCost * res.data[0].quantity});
				setFormErrors(validateFormValues(res.data[0]));
			});
		}else{

			if(params.id === 'create'){
				setAction(actions.create);
				createInit();
				setInputDisabled(false);
			}

		}
		
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(()=>{

		

	});

	const createInit = async () =>{
		let ini = initializeCreate();

		const theParam = context.userInfo.empId

		const tempData = await sendGetRequest(`/${table}/assetcode/${ini.originatingBu}`);
		let assetCode;

		if(tempData.data){
			for(const item of tempData.data){
				assetCode = item.assetCode; 
			}
	  	}

		ini.assetTag = assetCode;

		console.log("Data Ini", ini);

		setFormValues({...ini});

	}

	const initializeLists = (e) => {
		let path = '/depts';
		setRequesting(true);

		sendGetRequest(path).then((res) => {
			setRequesting(false);
			const tempItems = [];
			

			if(res.data){
				
				for(const item of res.data){
					tempItems.push({value: item.deptName, displayText: item.deptName})
				}
				setDepartments(tempItems);
			}
		});

		path = '/company';
		sendGetRequest(path).then((res) => {
			setRequesting(false);
			const tempItems = [];
			

			if(res.data){
				
				for(const item of res.data){
					tempItems.push({value: item.companyName, displayText: item.companyName})
				}
				setCompanies(tempItems);
			}
		});

		path = '/misc?config_type=uom';
		sendGetRequest(path).then((res) => {
			setRequesting(false);
			const tempItems = [];
		

			if(res.data){
				
				for(const item of res.data){
					tempItems.push({value: item.configName, displayText: item.configName})
				}
				setUom(tempItems);
			}
		});

		path = '/misc?config_type=AssetStat';
		sendGetRequest(path).then((res) => {
			setRequesting(false);
			const tempItems = [];
			

			if(res.data){
				
				for(const item of res.data){
					tempItems.push({value: item.configName, displayText: item.configName})
				}
				setAssetStatuses(tempItems);
			}
		});

		path = '/misc?config_type=Location';
		sendGetRequest(path).then((res) => {
			setRequesting(false);
			const tempItems = [];
			

			if(res.data){
				
				for(const item of res.data){
					tempItems.push({value: item.configName, displayText: item.configName})
				}
				setLocations(tempItems);
			}
		});

		path = '/misc?config_type=Insurance';
		sendGetRequest(path).then((res) => {
			setRequesting(false);
			const tempItems = [];
			

			if(res.data){
				
				for(const item of res.data){
					tempItems.push({value: item.configName, displayText: item.configName})
				}
				setInsurance(tempItems);
			}
		});

		path = '/company';
		sendGetRequest(path).then((res) => {
			setRequesting(false);
			const tempItems = [];
			

			if(res.data){
				
				for(const item of res.data){
					tempItems.push({value: item.companyName, displayText: item.companyName})
				}
				setbusUnit(tempItems);
			}
		});
	}

	const onSubmit = (e) => {
		e.preventDefault();
		setRequesting(true);
		
		let postData = {...formValues};
		// delete postData.docNo;
		// delete postData.organization;
		// delete postData.location;
		// delete postData.role;
		// delete postData.emailAdd;
		// delete postData.username;
		delete postData.createdBy;
		delete postData.createdDate;
		delete postData.updatedDate;
		delete postData.updatedBy;
		
		//postData.id = postData.idMaster;
		//delete postData.idMaster;

		if(action === 'create'){
			postData = {...postData, idMaster:'0'}
		}
		
		console.log('POST DATA', postData);
		
		/*
		Note to Edison: do not include  email add, role, and user name. Should be capture on the middleware
		*/
		postData = {...postData};
			sendPostRequest(`/${table}`, postData).then((res) => {
				setRequesting(false);
				if (res.error) {
					setSuccess(false);
					setStatus(res.error.response.data.message);
					alert(res.error.response.data.message);
					return;
				}
				if(action === actions.create){
					setFormValues({ ...formValues, idMaster: res.data[0].idMaster });
				}
				setInputDisabled(true);
				setAction(null);
				setStatus(null);
				setSuccess(true);
				alert("Data comitted successfully!");
			});
	};
	
	const deleteRecord = () =>{
		setRequesting(true);
       
		let postDeleteData = {...formValues, id: formValues.idMaster};
		delete postDeleteData.createdBy;
		delete postDeleteData.createdDate;
		delete postDeleteData.updatedDate;
		delete postDeleteData.updatedBy;
		console.log(postDeleteData);

		sendDeleteRequest(`/${table}`, postDeleteData).then((res) => {
			setRequesting(false);
			if (res.error) {
				setSuccess(false);
				setStatus(res.error.message);
				return;
			}
			
			setFormValues({...initializeCreate()});
		});
	}

	/*const getAssetCode = async () =>{
		const theBu = 'Hedcor, Inc. - Benguet'; // change with dynamic company
		const tempData = await sendGetRequest(`/${table}/assetcode/${theBu}`);
		if(tempData.data){
			for(const item of tempData.data){
			setFormValues({...formValues, assetTag: item.assetCode,
				                          idMaster: '0'
	  									 //,asset_tag: ''
	  									 ,asset_desc: ''
	  									 ,serial_no: ''
	  									 ,uom: ''
	  									 ,asset_stat: ''
	  									 ,acq_date: new Date()
	  									 ,acq_cost: ''
	  									 ,remarks: ''
	  									 ,quantity: 1
	  									 ,cic:''
                                      }); 
			console.log(tempData.data);	
		}
	  }
  	}*/

	const getAssetCode = async (theBU) =>{
		const theParam = context.userInfo.empId

		const tempData = await sendGetRequest(`/${table}/assetcode/${theBU}`);
		if(tempData.data){
			for(const item of tempData.data){
				setFormValues({...formValues, assetTag: item.assetCode, originatingBu: theBU}); 
			}
	  	}

  	}

	const handleChangeBU = (event) => {
		if(actions.create === action){
			getAssetCode(event.target.value)
			console.log(event.target.value)
			
			setFormErrors({
				...formErrors,
				...validateForm(event.target.name, event.target.value),
			});
		}
	};  

	const handleClose = (e, p) => {
		
		switch(p){
			case 'Create':
				if(context.userInfo.role==='Admin'){
					setAction(actions.create);
					createInit();
					
					setInputDisabled(false);
					//getAssetCode();
				}else{
					alert('Your current credential is not allowed to perform this action.')
				}
				break;
			
			case 'Edit':
				if(context.userInfo.role==='Admin'){
					if(formValues.idMaster){
						if(parseInt(formValues.idMaster) > 0){
							setAction(actions.edit);
							setInputDisabled(false);
						}else{
							
							alert("ID not found.");
						}
					}else{
						
						alert("ID not found.");
					}	
				}else{
					alert('Your current credential is not allowed to perform this action.')
				}
				
				break;
			
			case 'Search':
				setAction(null);
				setInputDisabled(true);
				history.goBack();
				break;		
			
			case 'Delete':
				if(context.userInfo.role==='Admin'){
					setAction(actions.delete);
					deleteRecord();
				}else{
					alert('Your current credential is not allowed to perform this action.')
				}
				
				break;	

			case 'Back':
				setInputDisabled(true);
				setAction(null);
				history.goBack();
				break;
			default:
				console.log(e);
		}
		
		setAnchorEl(null);
	};

	

	const handleDateChange = (e) =>{
		if(inputDisabled)return;
		setFormValues({...formValues, acqDate: e})

	}

	const handleChange = (event) => {
		if(inputDisabled)return;
		let value = event.target.name === 'assetDesc' || event.target.name === 'remarks' ?  event.target.value.toString().toUpperCase() : event.target.value;

		let total_cost = 0.00;
		
		if(event.target.name === 'acqCost'){
			total_cost = event.target.value * formValues.quantity;
		}

		if(event.target.name === 'quantity'){
			total_cost = formValues.acqCost * event.target.value;
		}
			

		setFormValues({ ...formValues, [event.target.name]: value, totalCost: total_cost });
		setFormErrors({
			...formErrors,
			...validateForm(event.target.name, event.target.value),
		});
	};
	
	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const setValue = (p_record) =>{
		if(inputDisabled)return;
		setFormValues({...formValues, assigneeEmpId: p_record[0].empId, assignee: p_record[0].lastName + ', ' + p_record[0].firstName })

	}

	/*const genAssetTag = () =>{

		let d = new Date();
		let t = d.getTime();

		setFormValues({...formValues, assetTag: `A-${t}-${context.userInfo.id}`})

	}*/

	return (
	<Content>
		<div>
			<IconButton
				aria-label="more"
				aria-controls="long-menu"
				aria-haspopup="true"
				onClick={handleClick}
			>
				<MoreVertIcon />
			</IconButton>
			<IconButton
				aria-label="more"
				aria-controls="long-menu"
				aria-haspopup="true"
			>
				
				<h5>Assets: {action} </h5>
			</IconButton>
			
			<Menu
				id="long-menu"
				anchorEl={anchorEl}
				keepMounted
				open={open}
				onClose={handleClose}
				PaperProps={{
				style: {
					maxHeight: ITEM_HEIGHT * 5,
					width: '20ch',
				},
				}}
			>
				{options.map((option) => (
				<MenuItem key={option}  onClick={(e)=>handleClose(e, option)}>
					
					<ListItemIcon>
						<ChevronRightTwoToneIcon fontSize="small"/>
					</ListItemIcon>
					<ListItemText primary={option} />	
					
				</MenuItem>
				))}
			</Menu>
		</div>
		<form className={classes.form} onSubmit={onSubmit}>
		
			<Blocker open={requesting} />
			{!closeModal && success && (<Redirect to={{ pathname: `${formValues.idMaster}` }} />)}

			{success === false && <ErrorAlert>Failed: {status}</ErrorAlert>}
			<Grid
				container
				direction="column"
				justifyContent="flex-start"
				alignItems="center"
				spacing={3}
			>
				<Grid item xs={12} md={8} style={{'width':'100%'}}>
					<BasicDropDown 
						errorMessage={formErrors.originatingBu}
						name="originatingBu"
						label="Business Unit"
						value={formValues.originatingBu || ' '} 
						onChange={handleChangeBU}
						options={busUnit}
						disabled = { inputDisabled }
					/>
				</Grid>

				<Grid item xs={12} md={8} style={{'width':'100%'}} disabled>
					<FormControl fullWidth variant="outlined">
						<InputLabel htmlFor="assetTag">Asset Tag</InputLabel>
						<OutlinedInput
							id="assetTag"
							value={formValues.assetTag || ' '}
							onChange={handleChange}
							labelWidth={150}
							inputProps={
								{ readOnly: true, }
							}
							label="Asset Tag"
						/>
					</FormControl>
				</Grid>
				<Grid item xs={12} md={8} style={{'width':'100%'}}>
					<TextField
						label="Asset Description"
						multiline
						rows={10}
						variant="outlined"
						name="assetDesc"
						fullWidth
						value={formValues.assetDesc || ''}
						onChange={handleChange}
						helperText={formErrors.assetDesc || ''}
						error={!!formErrors.assetDesc || false}
						required
						disabled = { inputDisabled }
					/>
				</Grid>
				<Grid item xs={12} md={8} style={{'width':'100%'}}>
					<TextField
						label="Serial Number"
						variant="outlined"
						name="serialNo"
						fullWidth
						value={formValues.serialNo || ''}
						onChange={handleChange}
						helperText={formErrors.serialNo || ''}
						error={!!formErrors.serialNo || false}
						required
						disabled = { inputDisabled }
					/>
				</Grid>
				
 
				<Grid item xs={12} md={8} style={{'width':'100%'}}>
					<BasicDropDown 
						errorMessage={formErrors.uom}
						name="uom"
						label="Unit of Measure"
						value={formValues.uom || ' '}
						//defaultValue=''
						onChange={handleChange}
						options={uom}
						disabled = { inputDisabled }
					/>
				</Grid>

				<Grid item xs={12} md={8} style={{'width':'100%'}}>
					<BasicDropDown 
						errorMessage={formErrors.assetStat}
						name="assetStat"
						label="Asset Status"
						value={formValues.assetStat || ' '} 
						
						onChange={handleChange}
						options={assetStatuses}
						disabled = { inputDisabled }
					/>
				</Grid>

				<Grid item xs={12} md={8} style={{'width':'100%'}}>
					<BasicDropDown 
						errorMessage={formErrors.cic}
						name="cic"
						label="Insurance"
						value={formValues.cic || ' '} 
						
						onChange={handleChange}
						options={insurance}
						disabled = { inputDisabled }
					/>
				</Grid>
			

			
				<Grid item xs={12} md={8} style={{'width':'100%'}}>
					<MuiPickersUtilsProvider utils={DateFnsUtils}>
							<KeyboardDatePicker
							inputVariant="outlined"
							name="acqDate"
							fullWidth
							id="date-picker-dialog"
							label="Acquisitiion Date"
							format="MM/dd/yyyy"
							value={formValues.acqDate}
							onChange={(e)=>handleDateChange(e)}
							disabled = { inputDisabled }
							KeyboardButtonProps={{
								'aria-label': 'change date',
							}}
							/>
						
						
					</MuiPickersUtilsProvider>
				</Grid>

				<Grid item xs={12} md={8} style={{'width':'100%'}}>
					<TextField
						label="Remarks"
						multiline
						rows={10}
						variant="outlined"
						name="remarks"
						fullWidth
						value={formValues.remarks || ''}
						onChange={handleChange}
						helperText={formErrors.remarks || ''}
						error={!!formErrors.remarks || false}
						required
						readOnly= { inputDisabled }
					/>
				</Grid>
				<Grid item xs={12} md={8} style={{'width':'100%'}}>
					<TextField
						label="Quantity"
						variant="outlined"
						name="quantity"
						fullWidth
						value={formValues.quantity || 1}
						onChange={handleChange}
						helperText={formErrors.quantity || ''}
						error={!!formErrors.quantity || false}
						required
						readOnly= { inputDisabled }
					/>
				</Grid>
				<Grid item xs={12} md={8} style={{'width':'100%'}}>
					<TextField
						step="0.01"
						type="number"
						 
						max="999999999999"
						label="Acquisition Cost"
						variant="outlined"
						name="acqCost"
						fullWidth
						value={formValues.acqCost || ''}
						onChange={handleChange}
						helperText={formErrors.acqCost || ''}
						error={!!formErrors.acqCost || false}
						required
						readOnly= { inputDisabled }
					/>
				</Grid>
				
				<Grid item xs={12} md={8} style={{'width':'100%'}}>
					<TextField
						type="text"
						label="Total Cost"
						variant="outlined"
						name="totalCost"
						fullWidth
						value={formValues.totalCost || 0}
						readOnly= { true }
					/>
				</Grid>

				<Grid item xs={12} md={8} style={{'width':'100%'}}>
					{
						inputDisabled === false > 0 ?
							<Button
							type="submit"
							fullWidth
							variant="contained"
							color="primary"
							className={classes.submit}
							disabled={!isEmpty(formErrors)}
							>
								Submit
							</Button>	
							: null
					}
					
				</Grid>
				
			</Grid>
		</form>
	</Content>
	);
};

AssetsForm.propTypes = formPropTypes;

AssetsForm.defaultProps = formDefaultPropValues;

export default AssetsForm;
